<template>
    <div>
        <el-form label-width="120px" label-position="top">
            <div>
                <template v-if="ref_id && !readonly">
                    <el-upload
                        style="display: inline-block"
                        class="upload-demo"
                        action="/filemanager/uploadbyrefid"
                        :show-file-list="false"
                        :data="{
                            ref_id: ref_id /*insPolicy.id*/,
                            ref_table: ref_table /*'ins_policy'*/,
                        }"
                        :on-progress="onFileProgress"
                        :on-success="onFileSuccess"
                        :on-error="onFileError"
                        :headers="{ Authorization: `Bearer ${authToken}` }"
                        :on-change="onFileChange"
                        multiple
                        ref="upload"
                        :auto-upload="!allowFileNameChange"
                    >
                        <el-button size="small" type="primary" :loading="fileUploading">{{
                            $t('Browse File')
                        }}</el-button>
                    </el-upload>
                </template>
                <template v-else-if="!ref_id">
                    <el-button>{{ $t('Save record to upload file.') }}</el-button>
                </template>
                <el-button
                    v-if="ref_id"
                    size="small"
                    type="primary"
                    class="bg-shadow"
                    :disabled="files.length == 0"
                    @click="downloadAll()"
                    :loading="downloadingFiles"
                    slot="reference"
                >
                    <i class="fa fa-cloud-download"></i>
                    {{ $t('Download All') }}
                </el-button>
                <el-table style="width: 100%" :data="files" ref="table" v-loading="fileUploading">
                    <template v-if="!$client.isMobile">
                        <el-table-column :label="$t('Name')" sortable prop="name">
                            <template slot-scope="scope">
                                <el-link type="primary" @click="goToFile(scope.row)">
                                    {{ scope.row.name }}
                                </el-link>
                            </template>
                        </el-table-column>
                        <el-table-column :label="$t('Created By')" prop="size" v-if="showCreatedBy">
                            <template slot-scope="scope">{{ scope.row.created_by_name }}</template>
                        </el-table-column>
                        <el-table-column :label="$t('Type')">
                            <template slot-scope="scope">{{ scope.row.mime_type }}</template>
                        </el-table-column>
                        <el-table-column :label="$t('Size')" prop="size">
                            <template slot-scope="scope">{{ scope.row.sizeInKb }} KB</template>
                        </el-table-column>
                        <el-table-column :label="$t('Date')">
                            <template slot-scope="scope">
                                {{ moment(scope.row.record_date_utc).format('lll') }}
                            </template>
                        </el-table-column>
                        <el-table-column width="120" v-if="!readonly">
                            <template slot-scope="scope">
                                <div class="row-actions">
                                    <el-button
                                        v-if="scope.row.created_by"
                                        size="small"
                                        type="danger"
                                        class="bg-shadow"
                                        @click="remove(scope.row)"
                                    >
                                        <i class="fa fa-trash"></i>
                                    </el-button>
                                </div>
                            </template>
                        </el-table-column>
                    </template>
                    <!-- Render in mobile -->
                    <template v-else>
                        <el-table-column :label="$t('Uploads')">
                            <template slot-scope="scope">
                                <el-link type="primary" @click="goToFile(scope.row)">{{
                                    scope.row.name
                                }}</el-link>
                                <description :leftText="$t('Type')">{{
                                    scope.row.mime_type
                                }}</description>
                                <description :leftText="$t('Size')">
                                    {{ scope.row.sizeInKb }} KB
                                </description>
                                <description :leftText="$t('Date')">
                                    {{ moment(scope.row.record_date_utc).format('lll') }}
                                </description>
                                <el-button
                                    v-if="scope.row.created_by && !readonly"
                                    size="small"
                                    type="danger"
                                    class="bg-shadow w-95 mt-3px"
                                    @click="remove(scope.row)"
                                >
                                    <i class="fa fa-trash"></i>
                                </el-button>
                            </template>
                        </el-table-column>
                    </template>
                </el-table>
            </div>
        </el-form>
        <el-dialog
            v-if="allowFileNameChange && selectedFile"
            :title="$t('Change File Name')"
            :visible.sync="fileNameModalVisible"
            append-to-body
            :close-on-click-modal="false"
        >
            <el-input
                :placeholder="$t('File Name')"
                v-model="selectedFileName"
                size="small"
                class="w-100"
            />
            <div slot="footer" class="dialog-footer">
                <el-button @click="onFileNameChange" type="primary" size="small">{{
                    $t('Save')
                }}</el-button>
                <el-button type="text" @click="onFileNameCancel" size="small">{{
                    $t('Cancel')
                }}</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import moment from 'moment';
import Model from '@/lib/data/Model';
import CollectionInfo from '@/data/uw/CollectionInfo';
import description from '../viewhelpers/description.vue';

export default {
    name: 'fileuploader',
    components: {
        description,
    },
    props: {
        ref_id: null,
        ref_table: null,
        files: null,
        owner: null,
        readonly: {
            type: Boolean,
            default: false,
        },
        allowFileNameChange: {
            type: Boolean,
            default: false,
        },
        showCreatedBy: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            moment,
            fileUploading: false,
            downloadingFiles: false,
            authToken: Model.getAuthToken(),
            collectionInfo: new CollectionInfo(),
            rules: {},
            fileNameModalVisible: false,
            selectedFile: null,
        };
    },
    mounted() {},
    computed: {
        selectedFileName: {
            get() {
                return this.selectedFile ? this.selectedFile.name.split('.')[0] : null;
            },
            set(value) {
                const originalName = this.selectedFile.raw.name;
                this.selectedFile.name = `${value}.${originalName.split('.')[1]}`;
            },
        },
    },
    watch: {
        fileNameModalVisible(value) {
            if (!value) {
                this.selectedFile = null;
            }
        },
    },
    methods: {
        goToFile(fileStorageItem) {
            window.open(this.getMediaSrc(fileStorageItem.id), '_blank');
        },
        getMediaSrc(id) {
            return `${window.location.origin}/file?id=${id}&auth_token=${this.authToken}`;
        },
        onFileProgress() {
            this.fileUploading = true;
        },
        onFileSuccess(response) {
            this.fileUploading = false;
            if (response.meta.return_code == 0) {
                this.owner.files.load(true, {
                    params: { id: this.ref_id },
                });
                this.$emit('fileuploadsuccess', this.owner, response.data);
            } else {
                this.$notify.error({
                    title: this.$t('Error'),
                    message:
                        response && response.meta
                            ? this.$t(response.meta.display_message)
                            : this.$t('Errors occured, please try again later'),
                });
            }
        },
        onFileError() {
            this.fileUploading = false;
        },
        downloadAll() {
            this.downloadingFiles = true;
            const a = document.createElement('a');
            a.style.display = 'none';
            document.body.appendChild(a);
            a.href = `/manager/downloadbyreftable?auth_token=${this.authToken}&ref_id=${this.ref_id}&ref_table=${this.ref_table}`;
            a.setAttribute('download', this.ref_id);
            a.click();
            window.URL.revokeObjectURL(a.href);
            document.body.removeChild(a);
            setTimeout(() => {
                this.downloadingFiles = false;
            }, 3000);
        },
        remove(file) {
            this.$confirm(
                this.$t('Are you sure you want to remove the file?'),
                this.$t('Warning'),
                {
                    confirmButtonText: this.$t('Yes'),
                    cancelButtonText: this.$t('Cancel'),
                    type: 'warning',
                }
            ).then(() => {
                file.removesoft({
                    params: {
                        id: file.id,
                    },
                    beforesend: () => {
                        this.loading = true;
                    },
                    complete: () => {
                        this.loading = false;
                    },
                    success: () => {
                        this.files.remove(file);
                    },
                    failure: (op, response) => {
                        this.$notify.error({
                            title: this.$t('Error'),
                            message:
                                response && response.meta
                                    ? response.meta.display_message
                                    : this.$t('Errors occured, please try again later'),
                        });
                    },
                });
            });
        },
        onFileChange(file) {
            if (this.allowFileNameChange && file && file.status != 'success') {
                this.selectedFile = file;
                this.fileNameModalVisible = true;
            }
        },
        onFileNameChange() {
            const originalFile = this.selectedFile.raw;
            const newFile = new File([originalFile], this.selectedFile.name, {
                type: originalFile.type,
                lastModified: originalFile.lastModified,
            });

            newFile.uid = this.selectedFile.uid;
            this.selectedFile.raw = newFile;
            this.$refs.upload.uploadFiles = [this.selectedFile];
            this.$refs.upload.submit();
            this.fileNameModalVisible = false;
        },
        onFileNameCancel() {
            this.fileNameModalVisible = false;
        },
    },
};
</script>

<style lang="scss">
.el-input-number.text-align-left {
    .el-input__inner {
        text-align: left !important;
    }
}
</style>
